import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { IconEmailOutline } from '@/components';

interface UpgradeModalProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

export const UpgradeModal = ({ title, isOpen, onClose }: UpgradeModalProps) => {
  const { t } = useTranslation(['interview']);
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="2xl"
        py={2}
        bgGradient="linear-gradient(98.02deg, rgba(191, 140, 255, 0.24) 4.7%, rgba(255, 46, 0, 0.0768) 78.56%, white 100%);"
      >
        <ModalHeader
          textAlign="center"
          color="primary.900"
          fontWeight="bold"
          fontSize="xl"
          pb={2}
        >
          {title}
        </ModalHeader>
        <ModalCloseButton bg="white" rounded="full" />
        <ModalBody pt={0}>
          <Text textAlign="center" mb={4} color="primary.900">
            {t('interview:upgradeModal.subTitle')}
          </Text>
          <VStack
            align="stretch"
            spacing={3}
            mb={4}
            bg="white"
            p={5}
            borderRadius="xl"
          >
            <HStack alignItems="center">
              <Box
                bg="primary.50"
                color="purple.600"
                borderRadius="full"
                w={7}
                h={7}
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight="bold"
              >
                1
              </Box>
              <Text
                fontSize="sm"
                borderBottomWidth={1}
                py={2}
                borderColor="primary.50"
                color="primary.900"
              >
                {t('interview:upgradeModal.desc1')}
              </Text>
            </HStack>
            <HStack alignItems="center">
              <Box
                bg="primary.50"
                color="purple.600"
                borderRadius="full"
                w={7}
                h={7}
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight="bold"
              >
                2
              </Box>
              <Text
                fontSize="sm"
                borderBottomWidth={1}
                py={2}
                borderColor="primary.50"
                color="primary.900"
              >
                {t('interview:upgradeModal.desc2')}
              </Text>
            </HStack>
            <HStack alignItems="center">
              <Box
                bg="primary.50"
                color="purple.600"
                borderRadius="full"
                w={7}
                h={7}
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontWeight="bold"
              >
                3
              </Box>
              <Text
                fontSize="sm"
                borderBottomWidth={1}
                py={2}
                color="primary.900"
                borderColor="primary.50"
              >
                {t('interview:upgradeModal.desc3')}
              </Text>
            </HStack>
            <HStack
              bg="primary.50"
              borderRadius="lg"
              px={3}
              py={2}
              justify="center"
            >
              <IconEmailOutline color="primary.500" fontSize={20} />
              <Text color="purple.700" fontWeight="semibold">
                destek@synapsai.ai
              </Text>
            </HStack>
          </VStack>
        </ModalBody>
        <ModalFooter mt={0}>
          <Button
            as="a"
            href="mailto:destek@synapsai.ai"
            colorScheme="primary"
            w="100%"
          >
            {t('interview:upgradeModal.buy')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
